import React from 'react'

const ViewProject = () => {
    return (
        <div>
          <div className="modal fade" id="infoSmsModal" tabindex="-1" aria-labelledby="infoSmsModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-lg">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title font-bold" id="infoSmsModalLabel">SMS Template Information</h5>
                <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <div className="information-section">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label htmlFor="project" className="form-label">Project</label>
                            <p id="project">REAl DO</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="title" className="form-label">Title</label>
                            <p id="title">Sample Title</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="types" className="form-label">Types</label>
                            <p id="types">Lead</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-12 mt-3">
                            <label htmlFor="remarks" className="form-label">Remarks</label>
                            <p id="remarks">This is a sample remark for the template.</p> {/* Replace with dynamic data */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                <button
                    type="button"
                    className="btn btn-outline-primary d-flex align-items-center gap-2"
                    style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                    data-bs-dismiss="modal"
                >
                    <i className="bi bi-x-circle"></i> Close
                </button>
                <button
                    type="button"
                    className="btn btn-gradient d-flex align-items-center gap-2"
                    style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                >
                    <i className="bi bi-pencil-square"></i> Edit
                </button>
            </div>
        </div>
    </div>
</div>




        </div>
    )
}

export default ViewProject
